// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"279":"c2f876e7ee848c7b","7156":"4c356232724f7af4","9343":"e1a185d25314cae3"}[chunkId] + ".css";
};